// components/LineChart.js
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface TwoBarsChartProps {
  data: any;
  options: any;
}

const TwoBarsChart = ({ data, options }: TwoBarsChartProps) => {
  return (
    <div className="line-chart h-[185px] w-full">
      <Bar data={data} options={options} style={{width: '100% !important'}} />
    </div>
  );
};

export default TwoBarsChart;
